"use client";

import { PageViewEvent as BasePageViewEvent } from "@marketing-sites/analytics/page-view-event";
import { PersonalizationInput } from "@marketing-sites/analytics/trigger-analytics-event";
import { TrackingData } from "@marketing-sites/analytics/types";
import { shouldHideLauncher } from "@/components/molecules/intercom-messenger";
import { trackMessengerVisibility } from "@marketing-sites/analytics/messenger-loaded";
import { useLogicalPathname } from "@/lib/l10n/providers";

export function PageViewEvent(
  props: Pick<TrackingData, "location" | "place"> & {
    personalization?: PersonalizationInput | null;
  },
) {
  // The launcher gate matches unprefixed routes, so predict its state from the
  // logical path rather than the browser pathname handed to onPageView —
  // otherwise /ps/view-demos reports the launcher as expected-visible while it
  // is correctly hidden.
  const logicalPathname = useLogicalPathname();

  return (
    <BasePageViewEvent
      {...props}
      platform="marketing-site-node"
      onPageView={() => {
        trackMessengerVisibility({
          platform: "intercom-com",
          expected: !shouldHideLauncher(logicalPathname),
        });
      }}
    />
  );
}
